import React, { useEffect, useRef, useState } from 'react';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import SignaturePad from "react-signature-canvas";

import signText from '../../../../Assets/Images/sing-text.png'
import useTailwindBrand from '../../../../Theme/useTailwindBrand';
import { BrandButton } from '../../../../Components/shared';
const Fifth = (props: any) => {
    const [dataURL, setDataURL] = useState<string | null>(null);
    const [show, setShow] = useState(true)
    const [open, setOpen] = useState(false)
    const [error, setError] = useState<boolean | null>(null)
    const [isSign, setIsSign] = useState(false)
    const [isApply, setApply] = useState(false);
    const [text, setText] = useState('')
    let padRef = useRef<SignaturePad>(null);

    const clear = () => {
        if (padRef) {
            padRef.current?.clear()
        }
        setDataURL(null)
        setShow(true)
    };
    const trim = () => {
        const url = padRef.current?.getTrimmedCanvas().toDataURL("image/png");
        if (url) {
            setDataURL(url)
        };
    };
    const validateSign = () => {
        trim()
        if (dataURL) {
            props.getSignature(dataURL)
            setOpen(false)
            setIsSign(true)
        }
    }
    const clearText = () => {
        setText('')
        setError(null)
    }
    const validateText = () => {
        if (text.toLowerCase().replace(/\s/g, '') === 'bonpourpouvoir') {
            setError(false)
            setApply(true)
            props.getSignatureText(signText)
        } else {
            setError(true)
            setTimeout(clearText, 2000)
        }
    }
    const { classes, brandConfig, common } = useTailwindBrand()
    return (
        <div className='flex md:pr-8 h-full gap-10'>

            <div className='relative w-full'>
                <div className='flex items-center pb-10 gap-x-4'>
                    <span className='hidden lg:inline'>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16" cy="16" r="16" fill={brandConfig.colors.primary} />
                            <path d="M16.8183 13.078C17.7863 13.078 18.637 13.2907 19.3703 13.716C20.1183 14.1267 20.6976 14.706 21.1083 15.454C21.519 16.202 21.7243 17.06 21.7243 18.028C21.7243 19.04 21.4896 19.9347 21.0203 20.712C20.5656 21.4893 19.913 22.098 19.0623 22.538C18.2263 22.9633 17.2583 23.176 16.1583 23.176C15.249 23.176 14.3543 23.0293 13.4743 22.736C12.609 22.428 11.8683 22.0173 11.2523 21.504C10.915 21.2107 10.7463 20.866 10.7463 20.47C10.7463 20.1473 10.8343 19.876 11.0103 19.656C11.201 19.4213 11.421 19.304 11.6703 19.304C11.817 19.304 11.9563 19.3333 12.0883 19.392C12.2203 19.436 12.3743 19.5167 12.5503 19.634C13.137 20.0447 13.709 20.36 14.2663 20.58C14.8236 20.8 15.4176 20.91 16.0483 20.91C17.0163 20.91 17.757 20.668 18.2703 20.184C18.7836 19.7 19.0403 19.0107 19.0403 18.116C19.0403 17.2507 18.7763 16.5687 18.2483 16.07C17.735 15.5567 17.0236 15.3 16.1143 15.3C15.5423 15.3 15.029 15.3807 14.5743 15.542C14.1343 15.7033 13.6796 15.9747 13.2103 16.356C12.9316 16.5467 12.6456 16.642 12.3523 16.642C12.059 16.642 11.8096 16.554 11.6043 16.378C11.399 16.202 11.2963 15.9673 11.2963 15.674V8.81C11.2963 8.39933 11.4136 8.07667 11.6483 7.842C11.883 7.60733 12.213 7.49 12.6383 7.49H19.9643C20.8443 7.49 21.2843 7.85667 21.2843 8.59C21.2843 9.32333 20.8443 9.69 19.9643 9.69H14.0683V13.87C14.8163 13.342 15.733 13.078 16.8183 13.078Z" fill="white" />
                        </svg>
                    </span>
                    <h2 className={`${classes.primaryText} ${classes.fontFamily} lg:text-[22px] text-lg font-bold`}>Signature</h2>
                </div>
                {isSign ?
                    <div className="">
                        <p className={`text-base lg:text-xl font-semibold ${classes.text}  ${classes.fontFamily}`}>Veuillez ajouter à votre signature la mention
                            <span>“bon pour pouvoir”</span> en l’écrivant ci-dessous.  </p>
                        {error === true ? <p className={`${classes.error} mt-4 mb-2  animate__animated animate__shakeX`}>Merci de bien vouloir taper "Bon pour pouvoir" pour terminer votre signature</p> : null}
                        {
                            error === false ?
                                <div className={`w-full ${classes.background} rounded-[9px] ${classes.primaryBorder} border p-4 flex-col flex gap-y-4 my-8`}>
                                    <div className='py-8 w-full'>
                                        <span className={`${classes.primaryText} border-b border-dashed ${classes.primaryBorder} w-3/4 block mx-auto text-center pb-2 text-3xl  font-buffalo`}>Bon pour pouvoir</span>
                                    </div>
                                </div> :
                                <div className={`w-full  rounded-[9px]  border p-4 flex-col flex gap-y-4 my-8 ${error === true ? `${classes.errorBorder} bg-[rgba(255,114,79,0.06)] animate__animated animate__shakeX` : 'border-[#D2D2D2] bg-white'}`}>
                                    <div className='py-8 w-full'>
                                        <input value={text} onChange={(e) => setText(e.target.value)} type="text" placeholder='Veuillez taper “bon pour pouvoir”' className={`${classes.fontFamily} bg-transparent block w-3/4 mx-auto text-center 2xl:text-xl font-bold border-b border-[#D2D2D2] border-dashed pb-2 text-sm`} />
                                    </div>

                                </div>
                        }
                    </div>
                    :
                    <div className="md:pr-10">
                        <p className={`text-base lg:text-xl font-bold ${classes.text}  ${classes.fontFamily}`}>Veuillez signer votre procuration, merci de bien <br /> vérifier l’ensemble des informations mentionnés </p>
                        <div className='w-auto xl:max-w-lg 2xl:max-w-none bg-white rounded-[9px] border-[#D2D2D2] border p-4 flex-col flex gap-y-4 my-8 relative '>
                            {show &&
                                <div className='absolute left-0 w-full top-[50%]  '>
                                    <div className=' w-5/6 mx-auto  border-[#D2D2D2]'>
                                        <p className='text-[#D2D2D2] font-bold text-base lg:text-xl text-center cursor-default select-none'>Signer ici</p>
                                    </div>
                                </div>
                            }
                            <div className="flex items-center justify-between ">
                                <div className='flex items-center gap-x-4'>
                                    <Button className={`cursor-pointer ${classes.background} ${classes.primaryBorder} border-solid border`} title='dessiner'>
                                        <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15.2424 3.03668H13.6618C13.2023 3.03668 12.798 3.31237 12.6325 3.71672C12.3201 3.51454 11.9525 3.29399 11.5482 3.05506C11.3644 2.94479 11.1622 2.83451 10.96 2.76099L11.1438 2.5772C11.6952 2.02582 11.6952 1.12524 11.1438 0.555479L11.0519 0.463583C10.5006 -0.0877958 9.59997 -0.0877958 9.03021 0.463583L7.02687 2.46692C5.39111 2.52206 3.60832 3.34913 2.90991 3.71672C2.70773 3.82699 2.50556 3.97403 2.35853 4.13944C0.943324 5.6833 0.373566 6.87795 0.336807 6.91471L0.300049 7.00661V7.0985C0.355187 7.7234 0.686014 8.1645 1.25577 8.34829L0.557359 10.5722C0.5206 10.7008 0.557359 10.8479 0.649255 10.9398C0.722772 11.0133 0.814669 11.05 0.906565 11.05C0.943324 11.05 0.980082 11.05 1.01684 11.0317L3.31425 10.3333C3.36939 10.3149 3.42453 10.2781 3.46129 10.2414L4.0678 9.63484C4.26997 9.72674 4.47215 9.7635 4.6927 9.7635H6.76956C7.52311 9.80026 8.40531 9.81864 9.25076 9.81864C10.9233 9.81864 12.4488 9.7635 12.4488 9.7635H12.6877C12.8899 10.0943 13.2391 10.3149 13.6618 10.3149H15.224C15.8489 10.3149 16.3452 9.81864 16.3452 9.19374V4.15782C16.3635 3.53292 15.8489 3.03668 15.2424 3.03668ZM1.0536 7.15364C1.20063 6.85957 1.77039 5.86709 2.89153 4.63568C2.98342 4.5254 3.11208 4.43351 3.24073 4.37837C3.77373 4.10268 4.96839 3.53292 6.1998 3.31237L1.78877 7.7234C1.20063 7.68664 1.07198 7.35581 1.0536 7.15364ZM3.02018 9.65322L1.47632 10.1311L1.95418 8.58723L7.41283 3.12858L7.43121 3.1102L9.54483 0.996582C9.82052 0.720893 10.2432 0.720893 10.5189 0.996582L10.6108 1.08848C10.8865 1.36417 10.8865 1.78689 10.6108 2.06258L5.55652 7.11688H4.63756C4.10456 7.11688 3.6267 7.39257 3.38777 7.85205C3.20398 8.20126 3.20398 8.58723 3.36939 8.95481C3.40615 9.02833 3.44291 9.10184 3.49804 9.17536L3.02018 9.65322ZM7.41283 6.7493C7.33931 6.95147 7.082 7.08012 6.71442 7.11688H6.58576L7.37607 6.32657C7.44959 6.49199 7.46797 6.63902 7.41283 6.7493ZM12.4488 9.02833C12.412 9.02833 9.01183 9.1386 6.78794 9.02833H4.6927C4.52728 9.02833 4.36187 8.97319 4.23322 8.88129C4.14132 8.80778 4.08618 8.73426 4.03104 8.64236C3.95753 8.47695 3.95753 8.32992 4.03104 8.18288C4.14132 7.98071 4.36187 7.85205 4.63756 7.85205H6.7328H6.82469L6.84307 7.83367C7.46797 7.76016 7.92745 7.46609 8.09286 7.00661C8.2399 6.62064 8.18476 6.17954 7.92745 5.7752L10.3719 3.34913C10.6476 3.42265 10.9233 3.5513 11.1806 3.69834C11.7136 4.01078 12.1547 4.28647 12.559 4.54378V9.04671L12.4488 9.02833ZM15.6284 9.19374C15.6284 9.41429 15.4446 9.57971 15.2424 9.57971H13.6618C13.4412 9.57971 13.2758 9.39591 13.2758 9.19374V4.15782C13.2758 3.93727 13.4596 3.77185 13.6618 3.77185H15.224C15.4446 3.77185 15.61 3.95565 15.61 4.15782V9.19374H15.6284Z" fill={brandConfig.colors.primary} />
                                        </svg>

                                    </Button>
                                </div>
                                <button onClick={clear} className={`cursor-pointer text-sm font-semibold ${classes.text}  ${classes.fontFamily}`}>
                                    Effacer
                                </button>
                            </div>
                            <SignaturePad onEnd={trim} onBegin={() => setShow(false)} ref={padRef} canvasProps={{ className: "sigCanvas border-2 border-dotted z-50" }} />
                        </div>
                    </div>
                }

                <div className="flex justify-end lg:py-10 pt-8">
                    <div className="flex justify-between w-full lg:gap-10 gap-y-4 flex-col lg:flex-row">
                        {/* <Button disabled={props.loading} onClick={() => props.callBack(4)} className='disabled:opacity-30 flex lg:w-1/3 w-full  lg:py-3 py-2 lg:text-xl font-semibold rounded-full gap-x-4 text-normal order-last lg:order-first text-base'>
                            <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 1L1.18919 9.84521C1.09139 9.92523 1.09139 10.0748 1.18919 10.1548L12 19" stroke="#4D4D4D" strokeWidth="1.5" strokeLinecap="round" />
                            </svg>
                            PRÉCÉDENT
                        </Button> */}
                        <BrandButton
                            disabled={props.loading} 
                            onClick={() => props.callBack(4)}
                            variant='outline'
                            className='w-full lg:w-max mx-auto block lg:text-xl rounded-full font-semibold'
                            children={
                                <>
                                     Précédent
                                </>
                            }
                        />
                        {
                            !isSign ?
                                // <Button disabled={dataURL ? false : true} onClick={() => setOpen(true)} className='disabled:opacity-30 lg:w-1/3 w-full lg:py-3 py-2 lg:text-xl font-extrabold text-white rounded-full bg-first text-base'  >SUIVANT</Button>
                                <BrandButton
                                    disabled={dataURL ? false : true}
                                    onClick={() => setOpen(true)}
                                    className='w-full lg:w-max mx-auto block lg:text-xl rounded-full font-semibold'
                                    children={'Suivant'}
                                />
                                : !isApply ?
                                    // <Button disabled={text !== '' ? false : true} onClick={validateText} className='disabled:opacity-30 lg:w-1/3 w-full lg:py-3 py-2 lg:text-xl font-extrabold text-white rounded-full bg-first text-base'  >SUIVANT</Button>
                                    <BrandButton
                                        disabled={text !== '' ? false : true}
                                        onClick={validateText}
                                        className='w-full lg:w-max mx-auto block lg:text-xl rounded-full font-semibold'
                                        children={'Suivant'}
                                    />
                                    :
                                    // <Button disabled={props.loading} onClick={() => props.callBack(5)} className='disabled:opacity-30 lg:w-1/3 w-full lg:py-3 py-2 lg:text-xl font-extrabold text-white rounded-full bg-first text-base'>SUIVANT</Button>
                                    <BrandButton
                                        disabled={props.loading}
                                        onClick={() => props.callBack(5)}
                                        className='w-full lg:w-max mx-auto block lg:text-xl rounded-full font-semibold'
                                        children={'Suivant'}
                                    />
                        }
                    </div>
                </div>
            </div>
            <Dialog
                fullWidth
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    "& .MuiPaper-root": {
                        borderRadius: "42px",
                        position: "relative",
                        overflow: "visible",
                        boxShadow: "4px 10px 20px 0px rgba(0,0,0,0.25)"

                    }
                }}
            >
                <div className="flex flex-col p-4 md:p-4 gap-y-4">
                    <DialogTitle id="alert-dialog-title" >
                    <h2 className={`mt-10 font-extrabold  uppercase ${classes.primaryText}  ${classes.fontFamily} lg:text-2xl text-center text-base`}> Appliquer cette signature</h2>
                    </DialogTitle>
                    <DialogContent className='flex flex-col gap-y-8 py-10'>
                    <p className={`${classes.text} ${classes.fontFamily} text-sm lg:text-lg font-semibold text-center`}>Êtes-vous certain de vouloir continuer ? En choisissant "oui", vous ne pourrez plus re-signer ce document</p>
                    </DialogContent>
                    <DialogActions className=''>
                        {/* <Button onClick={() => setOpen(false)} className='block w-1/3 py-2  mx-auto font-extrabold text-white rounded-full bg-third'>Non</Button>
                        <Button onClick={validateSign} className='block w-1/3 py-2  mx-auto font-extrabold text-white rounded-full bg-first'>Oui</Button> */}

                        <BrandButton
                            onClick={() => setOpen(false)}
                            // disabled={props.loading}
                            variant='outline'
                            className={`  mx-auto block  w-full lg:w-max font-semibold`}
                            children={'Non'}
                        />
                        <BrandButton
                            // disabled={props.loading}
                            onClick={validateSign}
                            className='w-full lg:w-max mx-auto block  lg:text-xl rounded-full font-semibold'
                            children={'Oui'}
                        />
                    </DialogActions>
                </div>
            </Dialog>
        </div>
    );
};

export default Fifth;